/**
 * Configuración › Portales: reglas de pantalla (window.FDPortales). Espejo de
 * application/helpers/portales_helper.php; el servidor siempre vuelve a validar.
 * Funciones puras (Vitest en entorno node, sin DOM).
 */

export const SLUG_RESERVADAS = ['admin', 'api', 'app', 'www', 'kiosko', 'login', 'static', 'soporte', 'facturadigital'];

/** Sin espacios en los extremos y en minúsculas. No translitera: "café" sigue siendo inválido. */
export function normalizarSlug(valor) {
    return String(valor == null ? '' : valor).trim().toLowerCase();
}

/** Por qué no sirve ese slug; '' si sirve (spec §3.1). Espejo de portal_slug_error. */
export function errorSlug(slug) {
    const s = String(slug == null ? '' : slug);
    if (!/^[a-z0-9][a-z0-9-]{1,28}[a-z0-9]$/.test(s)) return 'La dirección lleva de 3 a 30 caracteres: minúsculas, números y guion (sin guion al principio ni al final).';
    if (SLUG_RESERVADAS.indexOf(s) !== -1) return 'Esa dirección está reservada. Elige otra.';
    return '';
}

/** Escapa texto para pintarlo dentro de HTML. */
export function esc(texto) {
    return String(texto == null ? '' : texto)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/** Plazo para facturar (pantalla → kiosko.dias_limite_facturacion). null si no vale. Espejo de portal_plazo_regla. */
export function reglaPlazo(modo, dias) {
    if (['DU', 'DP', 'D10', 'D20', ''].indexOf(modo) !== -1) return modo;
    if (modo === 'dias') {
        const d = String(dias == null ? '' : dias).trim();
        return (/^\d+$/.test(d) && Number(d) >= 1 && Number(d) <= 365) ? String(Number(d)) : null;
    }
    return null;
}

const ACCIONES_CUENTA = {
    reenviar:    { icono: 'ti-send',         titulo: 'Reenviar activación' },
    restablecer: { icono: 'ti-mail-forward', titulo: 'Restablecer contraseña' },
    bloquear:    { icono: 'ti-lock',         titulo: 'Bloquear' },
    desbloquear: { icono: 'ti-lock-open',    titulo: 'Desbloquear' },
};

/**
 * Estado de una cuenta del portal (receptor_usuario.activo). Espejo de portal_estado_cuenta; además, una cuenta sin
 * activar que se registró sola (autorregistro: su token no es de invitación) lo dice: su correo nadie lo confirmó.
 */
export function estadoCuenta(activo, autorregistro) {
    switch (Number(activo)) {
        case 0: return autorregistro === true
            ? { clave: 'autorregistro', etiqueta: 'Se registró sola · confirma el correo', badge: 'badge-soft-warning' }
            : { clave: 'sin_activar', etiqueta: 'Sin activar', badge: 'badge-soft-warning' };
        case 1: return { clave: 'activo', etiqueta: 'Activo', badge: 'badge-soft-success' };
        case 2: return { clave: 'bloqueado', etiqueta: 'Bloqueado', badge: 'badge-soft-secondary' };
        default: return { clave: 'otro', etiqueta: 'Inactivo', badge: 'badge-soft-secondary' };
    }
}

/** Acciones que admite una cuenta según su estado. Espejo de portal_acciones_cuenta. */
export function accionesCuenta(activo) {
    switch (Number(activo)) {
        case 0: return ['reenviar', 'bloquear'];
        case 1: return ['restablecer', 'bloquear'];
        case 2: return ['desbloquear'];
        default: return [];
    }
}

/**
 * Botones de acción de una fila (delegación por data-accion; sin onclick en línea). Con autorregistro, «Reenviar
 * activación» lleva data-pide-correo="1": la pantalla pide el correo antes de mandarla (el servidor lo exige).
 */
export function botonesCuenta(id, activo, autorregistro) {
    const n = Number(id);
    const seguro = Number.isFinite(n) ? n : 0;
    return accionesCuenta(activo).map(function (a) {
        const def = ACCIONES_CUENTA[a];
        const pide = (a === 'reenviar' && autorregistro === true) ? ' data-pide-correo="1"' : '';
        return '<button type="button" class="btn btn-ghost btn-icon btn-sm' + (a === 'bloquear' ? ' fd-peligro' : '') + '"'
            + ' data-accion="' + a + '" data-id="' + seguro + '"' + pide + ' title="' + def.titulo + '" aria-label="' + def.titulo + '">'
            + '<i class="ti ' + def.icono + '"></i></button>';
    }).join('');
}

/** Texto comparable: sin acentos, en minúsculas y sin espacios en los extremos. */
export function normalizarBusqueda(texto) {
    return String(texto == null ? '' : texto).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

/**
 * Filtra las tarjetas de Integraciones. filtro.grupo: 'todas' (predeterminado), 'disponibles' o una llave de grupo;
 * filtro.texto busca en nombre y descripción, sin acentos ni mayúsculas.
 */
export function filtrarIntegraciones(items, filtro) {
    const f = filtro || {};
    const q = normalizarBusqueda(f.texto);
    const g = f.grupo || 'todas';
    return (items || []).filter(function (i) {
        if (g === 'disponibles' && i.estado !== 'disponible') return false;
        if (g !== 'todas' && g !== 'disponibles' && i.grupo !== g) return false;
        return q === '' || normalizarBusqueda((i.nombre || '') + ' ' + (i.descripcion || '')).indexOf(q) !== -1;
    });
}
